import { Env } from '@stencil/core';

declare global {
  interface Window {
    assetPathPrefix: string;
    stage: string;
  }
}

const PROTOCOL = 'https';
const LOCAL_PROTOCOL = 'http';
const LOCALHOST_PORT = '3333';
const CDN_BASE_URL = '.hornbach';
const LOCALE = 'de';
const LOCAL_DEV_PAGES_BASE_PATH = '/pages/';
const DEV_PAGES_BASE_PATH = `/${Env.tenantEnv}/media/stencil${Env.branchEnv}/stencil-pages/pages/`;

// BRANCH_PATH already contains the leading '/'
const ASSET_PATH_PREFIX = window.assetPathPrefix || `${Env.tenantEnv}/cms/`;
const ASSET_PATH = `${ASSET_PATH_PREFIX}media/stencil${Env.branchEnv}/dist/cms-components/assets`;
const LOCAL_ASSET_PATH = 'build/assets';
/* const LOCAL_DATA_PATH = 'local-dev/data'; */
const CONTENT_SERVICE_API_BASE_PATH = '/content';
const GOOGLE_MAPS_API_KEY = 'AIzaSyCE1xFLO1e8sBcFYP6qfHQJ7IlEYeiTqCE';

const resources = {
  local: {
    devPagesPath: LOCAL_DEV_PAGES_BASE_PATH,
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    cdn: `${PROTOCOL}://media.dev${CDN_BASE_URL}.${LOCALE}`,
    stage: window.stage || `${LOCAL_PROTOCOL}://localhost:${LOCALHOST_PORT}`,
    assetPath: `/${LOCAL_ASSET_PATH}`,
    contentServiceApi: `${PROTOCOL}://service.cmscontent.dev.shop.hosting.hcp.k8s.hornbach.cloud${CONTENT_SERVICE_API_BASE_PATH}`,
  },

  dev: {
    devPagesPath: DEV_PAGES_BASE_PATH,
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    cdn: `${PROTOCOL}://media.dev${CDN_BASE_URL}.${LOCALE}`,
    stage: window.stage || `${PROTOCOL}://dev.${Env.tenantEnv}.${LOCALE}`,
    assetPath: `/${ASSET_PATH}`,
    contentServiceApi: `${PROTOCOL}://service.cmscontent.dev.shop.hosting.hcp.k8s.hornbach.cloud${CONTENT_SERVICE_API_BASE_PATH}`,
  },
  int: {
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    cdn: `${PROTOCOL}://media.int${CDN_BASE_URL}.${LOCALE}`,
    stage: window.stage || `${PROTOCOL}://int.${Env.tenantEnv}.${LOCALE}`,
    assetPath: `/${ASSET_PATH}`,
    contentServiceApi: `${PROTOCOL}://int-svc.hornbach.de/cmscontent-service${CONTENT_SERVICE_API_BASE_PATH}`,
  },
  stage: {
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    cdn: `${PROTOCOL}://media${CDN_BASE_URL}.${LOCALE}`,
    stage: window.stage || `${PROTOCOL}://stage.${Env.tenantEnv}.${LOCALE}`,
    assetPath: `/${ASSET_PATH}`,
    contentServiceApi: `${PROTOCOL}://svc.hornbach.de/cmscontent-service${CONTENT_SERVICE_API_BASE_PATH}`,
  },
  prod: {
    mapsApiKey: GOOGLE_MAPS_API_KEY,
    cdn: `${PROTOCOL}://media${CDN_BASE_URL}.${LOCALE}`,
    stage: window.stage || `${PROTOCOL}://www.${Env.tenantEnv}.${LOCALE}`,
    assetPath: `/${ASSET_PATH}`,
    contentServiceApi: `${PROTOCOL}://svc.hornbach.de/cmscontent-service${CONTENT_SERVICE_API_BASE_PATH}`,
  },
};

export const endpoints = resources[Env.endpointEnv];
